import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { IGNORE_META_ERROR_MESSAGE } from '@sb/shared/util';
import { map } from 'rxjs';

import type { DocumentInReview, DocumentReviews, DocumentReviewsMeta } from './document-reviews.model';

@Injectable({ providedIn: 'root' })
export class DocumentReviewsApiService {
  #api = inject(ApiGateway);

  list() {
    return this.#api
      .get<{ data: DocumentInReview[]; meta: DocumentReviewsMeta }>('document-reviews', {
        meta: true,
        context: new HttpContext().set(IGNORE_META_ERROR_MESSAGE, true),
      })
      .pipe(
        map((response): DocumentReviews => ({
          rows: response.data,
          scopeLocationIds: response.meta.scope_location_ids,
        })),
      );
  }
}
